import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((_theme) => ({
    popupElement: {
        width: "100%",
        marginTop: 20,
    },
}));

export default function MaintenanceNote(props) {
    const { t } = useTranslation("translation");
    const classes = useStyles();
    return (
        <TextField
            id="bl_table_TextField_9"
            onChange={props.FilterWithMaintenanceNote}
            defaultValue={props.maintenanceNote}
            value={!props.maintenanceNote || props.maintenanceNote === "null" ? "" : props.maintenanceNote}
            label={t("WorkingNote")}
            variant="outlined"
            size={props.size ?? "normal"}
            className={classes.popupElement}
        />
    );
}
